import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppHeaderDropdown} from '@coreui/react';
import Clock from 'react-live-clock';
import './Style.css'
import {Label,Dropdown} from "semantic-ui-react";
import { Tooltip} from "antd";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import md_logo from  '../../assets/img/logos/md-logo.png';
import i18n from "i18next";
import {useTranslation, withTranslation} from "react-i18next";
import {compose} from "redux";
import {EN_LANG, SI_LANG, TA_LANG} from "../../const/constants";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  state = {
    lang: ''
  }

  componentDidMount() {
    const language = localStorage.getItem('language');
    if (language) {
      this.setState({lang: language});
      i18n.changeLanguage(language);

      if (language === EN_LANG) {
        document.getElementById('root').classList.value = "";
        document.getElementById('root').classList.add('en-lang');
      } else if (language === SI_LANG) {
        document.getElementById('root').classList.value = "";
        document.getElementById('root').classList.add('si-lang');
      } else {
        document.getElementById('root').classList.value = "";
        document.getElementById('root').classList.add('ta-lang');
      }


    } else {
      this.setState({lang: i18n.language});
    }
  }

  onLogout = () => {
    swal({
      title: "Do you want to sign out?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Sign-out",
          value: "action",
          className: "remove-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {

          case "action":

            this.props.userHandler([]);
            localStorage.removeItem('language');
            i18n.changeLanguage('en');
            Cookies.remove("68a6102f6ed24899420170004a0273b8");
            Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
            this.props.history.push('/');
            break;
          default:
        }
      });
  };

  changeLanguageHandler = (e) => {
    let value = e.target.value;
    this.setState({lang:value});
    i18n.changeLanguage(value);
    localStorage.setItem('language',value);
    /*document.getElementById('root').classList.add(value === SI_LANG ? 'si-lang' : value === ENG_LANG ? 'en-lang' : 'ta-lang');*/
    if (value === EN_LANG) {
      document.getElementById('root').classList.value = "";
      document.getElementById('root').classList.add('en-lang');
    } else if (value === SI_LANG) {
      document.getElementById('root').classList.value = "";
      document.getElementById('root').classList.add('si-lang');
    } else {
      document.getElementById('root').classList.value = "";
      document.getElementById('root').classList.add('ta-lang');
    }
  }


  render() {
    const {t} = this.props;
    let {language} = i18n.language;
    let {lang} = this.state;

    return (
      <React.Fragment>

        <h1 className={"logo-text"}>
          <img src={md_logo} className={"logo-main"} alt="." style={{width: '45px'}}/>
        </h1>

        {/*checkout/checkin details*/}

        <div style={{marginLeft: '10px'}} id={'nav-btn'}>
          {/*<Tooltip placement="topLeft" title="Schedule Meeting">*/}
            <Label onClick={() => this.props.history.push('/reception/dashboard')} color='grey' horizontal
                   style={{cursor: 'pointer'}}>
              {t('check_in_visitor')}
            </Label>
          {/*</Tooltip>*/}

          {/*<Tooltip placement="topLeft" title="View all not-checkout visitors">*/}
            <Label onClick={() => this.props.history.push('/reception/checkout')} color='orange' horizontal
                   style={{cursor: 'pointer'}}>
              {t('not_checked_out') + " : " + this.props.visitor_count_list.notCheckOut}
            </Label>
          {/*</Tooltip>*/}

          {/*<Tooltip placement="topLeft" title="View all visitors">*/}
            <Label onClick={() => this.props.history.push('/reception/visitorcount')} color='blue' horizontal
                   style={{cursor: 'pointer'}}>
              {t('total_visitors') + ": " + this.props.visitor_count_list.total}
            </Label>
          {/*</Tooltip>*/}

          {/*<Tooltip placement="topLeft" title="View all overdue visitors">*/}
            <Label onClick={() => this.props.history.push('/reception/overdue')} color='red' horizontal
                   style={{cursor: 'pointer'}}>
              {t('overdue') + " : " + this.props.visitor_count_list.overdue}
            </Label>
          {/*</Tooltip>*/}

          {/*<Tooltip placement="topLeft" title="View all history">*/}
            <Label onClick={() => this.props.history.push('/reception/history')} color='grey' horizontal
                   style={{cursor: 'pointer'}}>
              {t('history_viewer')}
            </Label>
          {/*</Tooltip>*/}

        </div>

        {/*date and time, dddd, YYYY MMMM D h:mm:ssa / YYYY M D h:mm:ssa*/}
        <Clock style={{fontSize: '14px', color: 'black', marginLeft: '25px'}} format="dddd, D-MMMM-YYYY | h:mm:ss A"
               ticking={true} interval={1000}/>

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px',
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>

            </DropdownToggle>
            <DropdownMenu right style={{right: 'auto'}}>
              <DropdownItem onClick={e => this.onLogout(e)}><i className="fa fa-lock"/> {t('logout')}</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
          <select style={{padding: '5px'}} value={lang} onChange={this.changeLanguageHandler}>
            <option value={EN_LANG}>English</option>
            <option value={SI_LANG}>සිංහල</option>
            <option value={TA_LANG}>தமிழ்</option>
          </select>
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  history: state.historyReducer.history,
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,

  visitor_count_list: state.reception_VisitorCountReducer.visitor_count_list,
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // userReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DefaultHeader));
